<template>
  <div
    ref="cont"
    class="dialog-template"
    :class="[
      { 'dialog-template_dark': dark },
      { 'centered mobile-fullscreen': mdAndDown },
      { 'centered desktop-fullscreen': desktopFullscreen },
      { 'scrollable-y': hasScrollY },
    ]"
  >
    <div
      v-if="$slots.dialog_title"
      class="dialog-template_title no-shrink"
      :style="titleStyle"
    >
      <slot name="dialog_title" />
    </div>

    <div
      class="dialog-template_content"
      :style="contentStyle"
      :class="[{ 'dialog-template_content_stretched': contentStretch }, contentClass]"
    >
      <slot />
    </div>

    <div
      v-if="$slots.dialog_actions"
      :style="actionsStyle"
      class="dialog-template_actions no-shrink"
      :class="actionsClass"
    >
      <slot name="dialog_actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogTemplate',
  props: {
    hasScrollY: Boolean,
    dark: Boolean,
    contentStretch: Boolean,
    contentClass: String,
    actionsClass: String,
    contentStyle: String,
    actionsStyle: String,

    titleStyle: String,
    subtitleStyle: String,
    desktopFullscreen: Boolean,
    persistent: Boolean,
  },
  emits: ['did:mount'],
  data() {
    return {}
  },
  mounted() {
    this.$emit('did:mount')
  },

  computed: {
    mdAndDown() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
  },
}
</script>

<style lang="scss" scoped>
.centered {
  align-items: center;
}
.mobile-fullscreen {
  max-height: var(--max-mobile-height) !important;
  min-height: var(--min-mobile-height) !important;
  min-width: 100vw !important;
  max-width: 100vw !important;
}
.desktop-fullscreen {
  min-height: var(--vh-6);
  min-width: calc(100vw - 6rem);
  max-width: calc(100vw - 6rem);
  height: 100vh;
}

.scrollable-y {
  .dialog-template_content {
    overflow-y: auto;
  }
}
.dialog-template {
  --max-mobile-height: var(--vh-100);
  --min-mobile-height: auto;
  --dialog-content-padding: 1rem 1rem 0 1rem;
  --dialog-content-overflow: auto;

  border-radius: 8px;
  box-shadow: var(--menu-shadow2);
  background: var(--clr-black-1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: var(--vh-3);
  max-width: 63rem;
  // max-width: 960px;
  min-height: 0;
  // &:focus {
  //   border: solid red 4px;
  // }
  &_dark {
    background: var(--clr-black-0) !important;
  }

  &_title {
    display: flex;
    padding: 1rem 1rem 0 1rem;
    width: 100%;
  }
  &_content {
    padding: var(--dialog-content-padding);
    // margin:: var(--dialog-content-margin);
    overflow-y: var(--dialog-content-overflow);
    overflow-x: hidden;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    &_stretched {
      padding: 0 !important;
      margin: 1rem 0 0 0 !important;
      height: 100%;
      width: 100%;
      flex: 1;
    }
  }
  &_actions {
    margin-top: auto;
    padding: 1rem;
    min-height: 4.25rem;
    flex-shrink: 0;
    display: flex;
    align-items: flex-end;
    width: 100%;
    z-index: 4;
  }
}

.content-chart {
  min-width: calc(100% - 2rem);
  height: 100%;
  flex: 1;
  margin-bottom: 1rem;
  display: flex;
  position: relative;
  overflow: hidden;
}

.range-study-dialog {
  .dialog-template_content {
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
